module.exports = __webpack_public_path__ + "img/fundo-login.70a90497.png";